var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLbUserIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.505,
    height: 41.053,
    viewBox: "0 0 31.505 41.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8861",
    "data-name": "Path 8861",
    d: "M343.18,819.639A13.559,13.559,0,1,1,356.739,833.2a13.56,13.56,0,0,1-13.559-13.559m-2.193,0a15.752,15.752,0,1,0,15.752-15.752,15.77,15.77,0,0,0-15.752,15.752",
    transform: "translate(-340.987 -803.887)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -6.216,
    y1: 13.076,
    x2: -6.197,
    y2: 13.076,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dea11e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c06c1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6812",
    "data-name": "Group 6812",
    transform: "translate(-668.24 -543.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8841",
    "data-name": "Path 8841",
    d: "M371.924,821.265a13.559,13.559,0,1,1-13.559-13.559,13.559,13.559,0,0,1,13.559,13.559",
    transform: "translate(325.628 -262.003)",
    fill: "#e1d3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842",
    "data-name": "Path 8842",
    d: "M347.172,851.181l3.153.051s0-.037.006-.105c.043-.729.3-5.049.4-6.462a2.326,2.326,0,0,1,.167-.714l1.054-2.6a14.542,14.542,0,0,1,.4,2.965,9.114,9.114,0,0,1-.073,1.528c-.017.119-.034.227-.052.3s-.028.114-.038.171c-.055.31-.2,1.156-.213,1.346,0,0-1.191,4.45-.922,5.577l1.652.2,2.19.267a9.658,9.658,0,0,0,3.813-.109l.111-.027c.485-.114,3.074-.952,3.074-.952-.368-1.873-.689-10.6-.689-10.6l1.684,1.326c.154.121.3.249.451.377a6.533,6.533,0,0,0,.887.615,1.887,1.887,0,0,0,2.4-.254,1.465,1.465,0,0,0,.1-.117l.051-.064h0c.263-.328.972-1.216,1.228-1.564.521-.705,1.955-2.823,2.067-2.987l.007-.01-2.833-1.829-.009.013-2.432,3.254-3.964-5.286a1.366,1.366,0,0,0-.506-.413c-.383-.179-.912-.369-.932-.377h-.5l.284,2.438.038.327-.871-.582-1.2-.8-1-.669-.04-.027-.317-.211h0l-1.116-.745-.338-.226-.288-.192-.458-.306-2.808,1.8a73.654,73.654,0,0,0-3.072,7.461l-.535,8.085Z",
    transform: "translate(324.62 -273.072)",
    fill: "#062c57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8843",
    "data-name": "Path 8843",
    d: "M353.906,857.962l1.652.2.357-6.5a14.171,14.171,0,0,0,.608-3.048,24,24,0,0,0-1.028-3.814l-.689,1.277a14.541,14.541,0,0,1,.4,2.965,9.12,9.12,0,0,1-.073,1.528c-.017.12-.034.227-.052.3s-.028.114-.039.171c-.055.31-.2,1.156-.213,1.346,0,0-1.191,4.45-.922,5.577",
    transform: "translate(321.771 -277.795)",
    fill: "#0a244a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8844",
    "data-name": "Path 8844",
    d: "M368.872,843.657l1.574,1.328,1.684,1.327c.154.121.3.249.451.377a6.569,6.569,0,0,0,.886.615,1.888,1.888,0,0,0,2.4-.254c.036-.037.068-.077.1-.117l.052-.064a4.359,4.359,0,0,1-3.245-.668,1.967,1.967,0,0,1-.561-.592,12.563,12.563,0,0,1-1.855-4.33.279.279,0,0,0-.1-.169l-.516-.442-.868,2.984Z",
    transform: "translate(315.382 -276.036)",
    fill: "#0a244a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8845",
    "data-name": "Path 8845",
    d: "M341.778,866.3l1.508-6.873.048-.216.226.046,1.46.294-.014.222-1.493-.3L342,866.348l9.372,1.885.823-3.713.7-3.156-3.74-.753h0l-1.049-.211c0-.073.009-.148.013-.223l.034.007,1.049.211,3.74.753.227.045-.048.216-.7,3.138-.827,3.731-.048.215-.226-.045-9.372-1.885-.226-.045Zm6.275-4.937-.009.154c0-.049.006-.1.009-.154m.027-.449-.02.323c.006-.1.013-.209.02-.323m-.036.6c0-.049.006-.1.009-.154Zm.017-.28c.006-.1.013-.209.02-.323Z",
    transform: "translate(326.937 -283.931)",
    fill: "#fff9f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8846",
    "data-name": "Path 8846",
    d: "M349.361,860.8l-1.049-.211-.1,1.585-3.151-.074.141-2.136-1.493-.3-1.509,6.873,9.373,1.885,1.523-6.869Z",
    transform: "translate(326.734 -284.124)",
    fill: "#060707"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8847",
    "data-name": "Path 8847",
    d: "M362.6,833.635h-3.556l1.086,5.822,2.225,3.714.715,1.135.1.048,1.291-6.636-1.267-3.605Z",
    transform: "translate(319.567 -273.042)",
    fill: "#c1c8d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8848",
    "data-name": "Path 8848",
    d: "M365.023,833.253a9,9,0,0,1,1.3.621,1.613,1.613,0,0,1,.326.257c.065.065.141.145.207.221.1.117.206.232.314.345s.256.268.313.331l-.327,1.249,1.2.357-.953,3.3a28.037,28.037,0,0,1-1.281,3.529l-.149.339q-.093.211-.172.428l-.337.932s.573-5.231.526-7.584-.361-2.907-.968-3.844Z",
    transform: "translate(317.021 -272.879)",
    fill: "#3a5075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8849",
    "data-name": "Path 8849",
    d: "M361.773,843.9s-3.671-9.487-3.7-10.23l-.481-.6-1.528,2.671,1.638,1.012-1.192.552s1,1.253,2,2.584c.716.956,1.412,1.976,1.822,2.5.346.439,1.42,1.729,1.42,1.729l.168-.168Z",
    transform: "translate(320.834 -272.798)",
    fill: "#3a5075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8850",
    "data-name": "Path 8850",
    d: "M362.187,835.308l.287.211h.067s.677,4.632.6,5.53h0c.677,1.788,1.231,3.221,1.243,3.25.075-.768.173-1.825.253-2.9-.051-.3-.138-.648-.215-1.051-.191-1.015-.428-2.28-.657-3.262-.238-1.029-.464-1.752-.464-1.752l.088-.013.025-.489-.56-.816-.462.049Z",
    transform: "translate(318.228 -273.203)",
    fill: "#c75044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8851",
    "data-name": "Path 8851",
    d: "M385.719,840.4l-.809,1.01-2.987-1.924.841-1.021Z",
    transform: "translate(309.826 -275.096)",
    fill: "#3a5075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8852",
    "data-name": "Path 8852",
    d: "M346.623,865.174l3.563.033.111-1.221-3.586-.084Z",
    transform: "translate(324.854 -285.927)",
    fill: "#3a5075"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8853",
    "data-name": "Path 8853",
    d: "M364.309,832.8l-.636-.736-.432,1.294.911.948Z",
    transform: "translate(317.779 -272.372)",
    fill: "#e0e0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8854",
    "data-name": "Path 8854",
    d: "M359.216,831.535l1.887,1.635-.551,1.534-1.826-2.292Z",
    transform: "translate(319.702 -272.148)",
    fill: "#e0e0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8855",
    "data-name": "Path 8855",
    d: "M384.8,837.148l.157-.2a3.887,3.887,0,0,1-.069-1.144.489.489,0,0,1,.133-.265l1.349-1.407s.556.273-.063,1.373a.081.081,0,0,0,.019.105.692.692,0,0,0,.381.079,2.239,2.239,0,0,0,.443-.034c.552-.1,2.47-.4,2.821-.006a.359.359,0,0,0,.152.1.693.693,0,0,0,.106.026.838.838,0,0,1,.214.063.371.371,0,0,1,.249.478.764.764,0,0,1-.485.6,10.36,10.36,0,0,1-2.624.433,1.167,1.167,0,0,0-.525.176,3.712,3.712,0,0,0-.72.632Z",
    transform: "translate(308.601 -273.252)",
    fill: "#f89d7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8856",
    "data-name": "Path 8856",
    d: "M348.755,866.137a4.086,4.086,0,0,0,.068.536,2.006,2.006,0,0,1,.04.527c-.034.644-.179,1.747-.207,2a2.281,2.281,0,0,0-.016.286.576.576,0,0,0,.115.34,3.316,3.316,0,0,0,1.343.848c.5.11.38-.2.293-.362a.53.53,0,0,1-.064-.23,1.833,1.833,0,0,1,.006-.287.045.045,0,0,1,.086-.006c.287.9.546.883.546.883.171-.009.144-.407.144-.407a10.655,10.655,0,0,0-.319-2.112.7.7,0,0,1,.007-.413,1.7,1.7,0,0,1,.163-.351,2.152,2.152,0,0,0,.45.269,1.521,1.521,0,0,0,.239.095c.672.2.722-.3.722-.3l-.379-.224c-.043-.025-.086-.05-.131-.071a2.269,2.269,0,0,1-.225-.132,1.452,1.452,0,0,1-.324-.3c-.178-.218-.542-.577-.542-.577Z",
    transform: "translate(323.996 -286.878)",
    fill: "#f89d7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8857",
    "data-name": "Path 8857",
    d: "M359.735,830.6v.612l1.608,1.394.462-.048.158-.471.216-.648a1.572,1.572,0,0,1,.047-.357V830.6Z",
    transform: "translate(319.272 -271.752)",
    fill: "#f89d7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8858",
    "data-name": "Path 8858",
    d: "M359.735,830.6v.056l.109-.017.066.345a2.241,2.241,0,0,0,.527.41,6.44,6.44,0,0,0,1.066.52c.146.056.289.118.459.173l.216-.648a1.572,1.572,0,0,1,.047-.357V830.6Z",
    transform: "translate(319.272 -271.752)",
    fill: "#e18364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8859",
    "data-name": "Path 8859",
    d: "M362.822,818.924l-.094,2.342a8.841,8.841,0,0,1-.149,2.456,1.767,1.767,0,0,1-.211.462,3.294,3.294,0,0,1-2.634,1.571s-4.126.51-4.188-2.526a1.591,1.591,0,0,1-.46-.149.577.577,0,0,1-.159-.131,1.428,1.428,0,0,1-.3-.593,2.838,2.838,0,0,1-.1-.578v-3.744h8.3Z",
    transform: "translate(321.491 -266.4)",
    fill: "#f89d7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8860",
    "data-name": "Path 8860",
    d: "M362.15,818.579l.094-2.342c-.45.434-2.885.163-4.24-.016a6.765,6.765,0,0,0-.962-.063c-.065,0-.107-.051-.136-.079a.053.053,0,0,0-.072,0,1.582,1.582,0,0,1-.293.2.4.4,0,0,1-.263.039c-.158-.03-.329-.061-.431-.082a.37.37,0,0,0-.381.149,5.045,5.045,0,0,0-.26,2.143.991.991,0,0,0-.144-.073,1.031,1.031,0,0,0-.575-.065.635.635,0,0,0-.543.72c-.482-.209-.744-2.518-.744-2.518a3.617,3.617,0,0,1,.208-1.826,2.57,2.57,0,0,1,.343-.611c1.113-1.472,1.981-1.327,1.981-1.327.251-1.137,2.507-1.154,3.686-1.084a9.09,9.09,0,0,1,1.012.125,6.584,6.584,0,0,0,1.054.094c-.082.279-.543.407-.543.407a1.613,1.613,0,0,0,1.9-.563,2.609,2.609,0,0,1,.607,1.351.671.671,0,0,1-.007.152,4.281,4.281,0,0,1-.08.574c-.09.453-.192.891-.222,1.018a2.145,2.145,0,0,1-.155.471,2.218,2.218,0,0,1-.19.332l-.385,2.844Z",
    transform: "translate(322.07 -263.713)",
    fill: "#4d2821"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(668.24 543.51)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 31.505,
    height: 31.505,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbUserIco);
export default __webpack_public_path__ + "static/media/lb-user-ico.d80deda17c241dca971c48722a21d527.svg";
export { ForwardRef as ReactComponent };